/** 秘密保持の項目 ID */
export const TERMS_CONFIDENTIALITY_SECTION_ID = '23';
/** ホットラインの項目 ID */
export const TERMS_HOTLINE_SECTION_ID = '11-1';
/** ホットライン エキスパートへの謝礼の項目 ID */
export const TERMS_HOTLINE_EXPERT_REWARD_SECTION_ID = '11-4';
/** ホットライン キャンセルポリシーの項目 ID */
export const TERMS_HOTLINE_CANCEL_POLICY_SECTION_ID = '11-5';
/**
 * 匿名コンサルホットライン 利用規約内容
 * @description モーダル表示と規約ページに表示するため定義を分けている
 */
export const TERMS_HOTLINE_HTML = `
<h4 id="item_${TERMS_HOTLINE_SECTION_ID}">第１１条（匿名コンサルホットラインサービスの内容）</h4>
<ol>
  <li>
    当社は、匿名コンサルホットラインサービスとして、第２項及び第３項に定める役務を提供します。
  </li>
  <li>
    登録ユーザーは、別途当社が定める方法により、匿名コンサルホットラインサービスとして次のサービスを利用することができます。
    <ol>
      <li>
        エキスパートから、匿名コンサルホットラインサービスとして本サービスサイト上で提供されるオンラインビデオ会議システム（以下「ビデオ会議システム」といいます。）を利用したビデオ会議（以下「ビデオ会議」といい、ビデオ会議においては会議の参加者の映像はアバター（仮想のキャラクター）に置き換えられます。）による助言を受けたい課題について匿名又は顕名で本サービスサイト上に投稿すること
      </li>
      <li>
        エキスパートから前号の課題について本件サービスサイトを通じて助言の提案の申し出を受けること
      </li>
      <li>
        エキスパートとの間で第１号の課題についてビデオ会議で助言を受けるためにビデオ会議システムを利用すること
      </li>
      <li>
        前号のビデオ会議の日程調整等のためにチャット機能を利用すること
      </li>
    </ol>
  </li>
  <li>
    エキスパートは、当社が指定する方法により、匿名コンサルホットラインサービスとして次のサービスを利用することができます。
    <ol>
      <li>
        登録ユーザーにより本サービスサイト上になされたビデオ会議による助言を受けたい課題についての投稿を閲覧すること
      </li>
      <li>
        前号の投稿をした登録ユーザーに対し、当該課題について本件サービスサイトを通じて助言の提案を申し出ること
      </li>
      <li>
        登録ユーザーとの間で第１号の課題についてビデオ会議で助言をするためにオンラインビデオ会議システムを利用すること
      </li>
      <li>
        前号のビデオ会議の日程調整等のためにチャット機能を利用すること
      </li>
    </ol>
  </li>
  <li>
    登録ユーザー及びエキスパートは、匿名コンサルホットラインサービスのチャット機能を用いて事前にビデオ会議の日時（開始時間及び終了時間）を定めるものとします。
  </li>
  <li>
    登録ユーザー及びエキスパートは、前項に基づき定めたビデオ会議の終了時間になった場合、別途当社が定める手続きに従いビデオ会議を終了させるものとします。なお、登録ユーザー又はエキスパートがビデオ会議を終了させる手続きを取らなかった場合、かかる手続きが取られるまでビデオ会議は延長されます。
  </li>
</ol>
<h4>第１１条の２（連絡先の開示の禁止）</h4>
<ol>
  <li>
    エキスパートは、別途当社が書面により承諾した場合を除き、匿名コンサルホットラインを通じてのみ連絡を行うものとし、匿名コンサルラインサービスの利用にあたり、登録ユーザーに対し、Web会議がつながらない場合の緊急連絡先以外の電話番号、メールアドレス等の連絡先を開示してはならないものとします。
  </li>
  <li>
    登録ユーザー及びエキスパートは、前項の違反の有無の確認のため、当社がビデオ会議やチャットの内容について調査（ＡＩを利用する方法を含みますが、これに限られません。）を行うことがあることを予め了承するものとします。
  </li>
</ol>
<h4>第１１条の３（匿名コンサルホットラインサービスの利用料等）</h4>
<ol>
  <li>
    登録ユーザーは、匿名コンサルホットラインサービスの利用料として、ビデオ会議の開催毎に別途当社が定める利用料を、別途当社が定めるところに従い、別途当社が指定する金融機関の口座に振込送金する方法で支払うものとします。振込手数料は登録ユーザーの負担とします。なお、ビデオ会議が延長された場合、追加の利用料が発生します。
  </li>
  <li>
    エキスパートは、匿名コンサルホットラインサービスを利用して課題への助言又はその申し出をした（以下本条において「助言等」と総称します。）登録ユーザーとの間で、助言等を行った日（複数回ある場合は最初の助言等を行った日）から１年以内にコンサルティングその他の役務の提供にかかる契約（以下「コンサルティング契約」といい、当該課題かかる助言等の役務を提供する契約に限りません。）を締結した場合、コンサルティング契約の締結日から３０日以内に書面又は電子メールその他の電磁的方法で当社に通知するとともに、匿名コンサルホットラインサービスの成果報酬として別途当社が定める料金表に定める金額を、別途当社が定める期日までに当社に支払うものとします。なお、助言等を行うことなくその申し出をした登録ユーザーとの間でコンサルティング契約を締結した場合も同様とします。この場合、成果報酬が発生する期間は最初に助言等の申し出をした日から１年間とします。
  </li>
  <li>
    エキスパートは、前項の成果報酬を、別途当社が指定する金融機関の口座に振込送金する方法で支払うものとします。振込手数料はエキスパートの負担とします。
  </li>
  <li>
    第２項の規定にかかわらず、匿名コンサルホットラインサービスを利用した登録ユーザーの部署と異なる部署からの依頼に基づきコンサルティング契約を締結した場合は、エキスパートは第２項に定める匿名コンサルホットラインサービスの成果報酬の支払義務を負わないものとします。なお、部署が同一か否かは、エキスパートと当社との協議により当社が定めるものとします。当社はかかる判断にあたり、可能な限り登録ユーザーにヒアリングを行うものとします。
  </li>
  <li>
    当社は、エキスパートが第２項の規定に違反した場合、第２７条（登録抹消等）第１項第１号の違反として、本サービスの利用を停止し、又はアカウント及び登録会員としての登録を抹消、若しくはサービス利用契約を解除することができます。
  </li>
  <li>
    理由の如何にかかわらず、当社は受領した匿名コンサルホットラインサービスの利用料及び成果の返還を行う義務を負わないものとします。但し、利用料についてはビデオ会議が開催されなかった場合はこの限りではありません。
  </li>
</ol>
<h4 id="item_${TERMS_HOTLINE_EXPERT_REWARD_SECTION_ID}">第１１条の４（エキスパートへの謝礼）</h4>
<p>
  当社は、第１１条（匿名コンサルホットラインサービスの利用料）第１項に定める利用料を受領した場合、別途当社が定める金額の謝礼を、別途当社が定めるところに従い、別途エキスパートが指定するエキスパート名義の金融機関の口座に振込送金する方法で支払うものとします。なお、かかる支払いにあたり、エキスパートは直近２ヶ月間の謝礼についての当社所定の書式の請求書を発行するものとします。また、謝礼の支払いにつきましては法令の定めがある場合を除き２ヶ月単位で行うものとし、直近２ヶ月間に発生した謝礼につきその翌月末日限りにまとめて行うものとします。
</p>
<h4 id="item_${TERMS_HOTLINE_CANCEL_POLICY_SECTION_ID}">第１１条の５（匿名コンサルホットラインサービスにおけるキャンセルの取扱い）</h4>
<ol>
  <li>
    登録ユーザーは、匿名コンサルホットラインサービス上において、ビデオ会議システムの日時が定まった場合、日時の変更、キャンセル等（以下「キャンセル等」といいます。）はできないものとします。但し、当該日時の２４時間前までに匿名コンサルホットラインサービスを通じてエキスパートに通知した場合はこの限りではないものとします。
  </li>
  <li>
    登録ユーザーは、前項但書の場合を除き、キャンセル等その他登録ユーザーの責めに帰すべき事由によりビデオ会議が開催されなかった場合といえども、第１１条（匿名コンサルホットラインサービスの利用料）第１項に定める匿名コンサルホットラインサービスの利用料を支払わなくてはならないものとします。
  </li>
  <li>
    エキスパートは、匿名コンサルホットラインサービス上において、ビデオ会議システムの日程が定まった場合、日程の変更、キャンセル等はできないものとします。但し、当該日程の２４時間前までに匿名コンサルホットラインサービスを通じて登録ユーザーに通知した場合はこの限りではないものとします。
  </li>
</ol>
`;
/**
 * 利用規約内容
 */
export const TERMS_HTML = `<h3>Proffit 利用規約</h3>
<h4>第１条（適用範囲）</h4>
<ol>
  <li>
    本利用規約は、合同会社Co-nnect
    Inc.（以下「当社」といいます。）が本サービス及び本サービスサイトについての利用条件を定めるものであり、本サービスの利用にかかる当社と本サービスの登録会員との一切の関係に適用されます。
  </li>
  <li>
    本サービスに関して、本利用規約とは別に「利用規約」、「ガイドライン」、「ポリシー」等の名称で当社が配布又はウェブサイト上に掲載している文書（以下「個別利用規約」といいます。）がある場合、登録会員は、本利用規約のほか個別利用規約の定めにも従って本サービスを利用しなければなりません。
  </li>
  <li>
    個別利用規約と本利用規約とで矛盾する内容が規定されている場合、矛盾する箇所に限り、個別利用規約の内容が優先して適用されます。
  </li>
</ol>
<h4>第２条（用語の定義）</h4>
<ol>
  <li>
    「本サービス」とは、当社が「Proffit（プロフィット）」の語を含むサービス名称で提供する、コンサルティング業務に関するマッチングサービス、及び、関連サービスをいいます。
  </li>
  <li>
    「本サービスサイト」とは、当社が「Proffit（プロフィット）」の名称で運営するウェブサイト及びその他の関連ウェブサイトいい、メールマガジン等本ウェブサイトから発信する情報を含むものをいいます。
  </li>
  <li>
    「Proffitサービス」とは、本サービスとして登録会員に提供する第９条（Proffitサービスの内容）第２項記載の役務をいいます。
  </li>
  <li>
    「Proffit
    Martサービス」とは、本サービスとして登録会員に提供する第１０条（Proffit
    Martサービスの内容）第２項及び第３項記載の役務をいいます
  </li>
  <li>
    「登録ユーザー」とは、第３条（登録）第３項記載の登録手続きを完了し、本サービスにおいて、ビジネスに関するアドバイスを求める法人をいいます。
  </li>
  <li>
    「エキスパート」とは、第３条（登録）第４項記載の登録手続きを完了し、本サービスにおいて、ビジネスに関するアドバイスを提供する自然人又は法人をいいます。
  </li>
  <li>
    「登録会員」とは、登録ユーザー及びエキスパートをいいます。
  </li>
  <li>
    「マッチングサービス」とは、登録ユーザーとエキスパートがコンサルティング取引を行うためのツール及びプラットフォームの提供及びこれに付随又は関連するサービスをいいます。
  </li>
  <li>
    「コンテンツ」とは、文章、画像、動画、音楽、音声、プログラム、コードその他の情報をいいます。
  </li>
  <li>
    「登録会員コンテンツ」とは、登録会員が本サービスに、送信・アップロードする等して当社の管理するサーバに保存させたコンテンツのことをいいます。
  </li>
  <li>
    「プロジェクト事例」とは、エキスパートが登録ユーザーに対して提供することを予定する特定のコンサルティング業務及びこれを記載したコンテンツをいいます。
  </li>
  <li>
    「当社提供コンテンツ」とは、当社が本サービスの提供の一環として、本サービス上で登録会員に対し利用可能なものとして提供したコンテンツのことをいいます。
  </li>
</ol>
<h4>第３条（登録）</h4>
<ol>
  <li>
    本サービスの全部の機能を利用するためには本条に定める登録（以下「会員登録」といいます。）が必要となります。会員登録を希望する者は、当社の定める一定の情報（以下「登録事項」といいます。）を当社の定める方法で当社に提供することにより、当社に対し、会員登録を申請することができます（以下、「登録申請者」といいます。）。なお、未成年者は本サービスの利用をすることができません。
  </li>
  <li>
    会員登録は、会員となる本人（法人の場合には対外的な契約権限を有する者とします。）のみが申請できるものとします。
  </li>
  <li>会員登録は、本名及び正式名称で行うものとします。</li>
  <li>
    登録申請者は、会員登録の申請により、本利用規約の全ての記載内容について有効かつ取り消し不能な同意をしたものとみなされます。
  </li>
  <li>
    登録申請者は、登録事項を当社の定める方法で当社に提供することにより登録手続きを完了し登録会員となり、本サービスを本利用規約に従い利用することができるようになります。
  </li>
  <li>
    登録申請者は、登録事項の提供にあたり、提供した情報は全て真実であることを保証するものとします。
  </li>
  <li>
    当社は、登録申請者が以下の各号のいずれかの事由に該当する場合は、登録及び再登録を拒否することがあり、またその理由について一切開示義務を負いません。
    <ol>
      <li>
        当社に提供した登録事項の全部又は一部につき虚偽、誤記又は記載漏れがあった場合
      </li>
      <li>
        経営戦略、組織戦略等の立案、業務改革等のいわゆるコンサルティング業務を他社に提供することをビジネスとする者による登録ユーザーとしての申込みであると当社が判断した場合
      </li>
      <li>
        反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずるものを意味します。以下同じ。）である、又は資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与を行っていると当社が判断した場合
      </li>
      <li>
        登録申請者が過去当社との契約に違反した者又はその関係者であると当社が判断した場合
      </li>
      <li>
        第２７条（登録抹消等）に定める措置を受けたことがある場合
      </li>
      <li>本利用規約に違反するおそれがある場合</li>
      <li>その他、当社が登録を適当でないと判断した場合</li>
    </ol>
  </li>
  <li>
    登録会員は、登録情報に変更があった場合、遅滞なく最新の情報に登録内容を変更するための当社所定の手続きを取るものとします。
  </li>
</ol>
<h4>第４条（アカウント）</h4>
<ol>
  <li>
    本サービスの登録に伴い、登録会員は１会員につき１つのアカウントを保有するものとします。
  </li>
  <li>
    登録ユーザーの従業員は、登録ユーザーのアカウントを用いて本サービスを利用することができます。
  </li>
</ol>
<h4>
  第５条（複数アカウントの保有及びアカウントの共有等の禁止）
</h4>
<ol>
  <li>
    当社が別途書面で認めたものを除き、登録会員が複数のアカウントを保有すること、複数の登録会員が１つ又は複数のアカウントを共同して保有することはできません。
  </li>
  <li>
    登録会員はいかなる場合においても、アカウントを第三者に譲渡又は貸与することはできません。
  </li>
</ol>
<h4>第６条（本サービスの提供方法）</h4>
<ol>
  <li>
    当社は、本サービスの一部の提供にあたり、事業規模、中心業務、業種、設立からの年数、経験、経歴その他当社が適切と判断する条件を満たした登録会員に限定することができるものとします。
  </li>
  <li>
    当社は、本サービスに当社又は第三者の広告を掲載することができるものとします。
  </li>
</ol>
<h4>第７条（本サービスの無保証）</h4>
<p>
  当社は、本サービス（本サービスにより提供される全てのコンテンツを含みます。）に事実上又は法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティ等に関する欠陥、エラーやバグ、権利侵害等を含みますが、これらに限りません。）がないことを保証しておりません。当社は、登録会員に対して、かかる瑕疵を除去して本サービスを提供する義務を負わず、本サービスの利用は、全て登録会員自らの責任において行うものとします。また、当社は、登録ユーザーとエキスパート間の紛争を含め登録会員間で生じたいかなる紛争についても責任を負いません。
</p>
<h4>第８条（登録会員による本規約違反の場合の措置）</h4>
<p>
  当社は、登録会員が本規約に違反して本サービスを利用していると判断した場合、必要かつ適切と当社が判断する措置を講じることができます。但し、当社は、登録会員及び第三者に対して、登録会員その他の者が本規約に違反しないことを保証するものではありません。また、当社は、登録会員及び第三者に対して、かかる違反を防止又は是正する義務を負いません。
</p>
<h4>第９条（Proffitサービスの内容）</h4>
<ol>
  <li>
    当社は、Proffitサービスとして、第２項に定める役務を通じて登録ユーザーとエキスパートとのマッチングサービスを提供します。当社は、登録ユーザーとエキスパートにそれぞれProffitサービスを提供しますが、当社が別段の定めを置く場合を除き、ユーザーとエキスパートとの間の契約の当事者とはなりません。
  </li>
  <li>
    登録ユーザーは、当社が指定する方法により、Proffitサービスとして次のサービスを利用することができます。
    <ol>
      <li>当社に課題相談を行うこと</li>
      <li>
        相談内容を踏まえて、エキスパートに課題の解決を依頼するための提案依頼書（以下単に「提案依頼書」といいます。）の作成を、当社に依頼すること
      </li>
      <li>
        当社ウェブサイト上の特定の場所に提案依頼書を掲載することによって、提案依頼書に対する提案を募集すること
      </li>
      <li>
        エキスパートから提案された課題の解決のための対応策（以下「プロジェクト」といいます。）の内容を閲覧すること
      </li>
      <li>
        エキスパートに面談（以下「直接面談」といいます。）を希望する連絡を行うこと
      </li>
    </ol>
    但し、直接面談したいエキスパートに連絡を取る場合、エキスパートの提案内容につき当社所定の方法で評価を行い、その結果を当社に報告することが必要となります。
  </li>
  <li>
    エキスパートは、当社が指定する方法により、Proffitサービスとして次のサービス利用することができます。
    <ol>
      <li>「プロジェクト一覧」の提案依頼書を閲覧すること</li>
      <li>
        プロジェクトへの提案を募集中のプロジェクトに対し、提案を行うこと（なお、提案に関し、他社と共同で提案を行う場合は、提案前に、必ず、共同で提案を行う会社も本サービスへの登録が必要となります。）
      </li>
      <li>
        当社が別途指定する方法により、ユーザーから直接提案依頼書に対する提案の依頼を受けること
      </li>
    </ol>
  </li>
</ol>
<h4>第９条の２（Proffitサービスの利用料）</h4>
<ol>
  <li>
    登録ユーザーは、当社が別途定める場合を除き、Proffitサービスを無料で利用できるものとします。
  </li>
  <li>
    エキスパートが、Proffitサービスのうち、プロジェクトへの提案の申し込みその他当社が別途定める特定のサービスの利用をするためには、利用料の支払が必要となります。
  </li>
  <li>
    第２項の利用料の額は、当社が別途定める料金表によります。
  </li>
  <li>
    エキスパートは、利用料を、利用料が発生した日の属する翌月末日までに、別途当社が指定する金融機関の口座に振込送金する方法で支払うものとします。振込手数料はエキスパートの負担とします。
  </li>
</ol>
<h4>第９条の３（Proffitサービスにおけるキャンセルの取扱い）</h4>
<ol>
  <li>
    エキスパートは、Proffitサービスの利用の申し込みを取り消すことはできないものとします。
  </li>
  <li>
    登録ユーザーは、当社ウェブサイト上で提案募集を行うまでは、Proffitサービスの利用を取り消すことができますが、提案募集を行った後は、Proffitサービスの利用を取り消すことができません。
  </li>
  <li>
    理由の如何にかかわらず、当社は受領したProffitサービスの対価の返還を行う義務を負わないものとします。但し、当社の責によりProffitサービスの提供が不能となった場合はこの限りではありません。
  </li>
</ol>
<h4>第１０条（Proffit Martサービスの内容）</h4>
<ol>
  <li>
    当社は、Proffit
    Martサービスとして、第２項に定める役務の提供を通じて登録ユーザーとエキスパートとのマッチングサービスを提供します。当社は、登録ユーザーとエキスパートにそれぞれProffit
    Martサービスを提供しますが、当社が別段の定めを置く場合除き、登録ユーザーとエキスパートとの間の契約の当事者とはなりません。
  </li>
  <li>
    登録ユーザーは、当社が指定する方法により、Proffit
    Martサービスとして次のサービスを利用することができます。
    <ol>
      <li>
        本サービスサイト上でエキスパートから提供されるプロジェクト事例を閲覧すること
      </li>
      <li>
        エキスパートにプロジェクト事例に関する打ち合わせを希望する連絡を行うこと
      </li>
    </ol>
  </li>
  <li>
    エキスパートは、当社が指定する方法により、Proffit
    Martサービスとして次のサービス利用することができます。
    <ol>
      <li>本サービスサイト上にプロジェクト事例を掲載すること</li>
      <li>
        登録ユーザーからの求めに応じてプロジェクト事例に関する打ち合わせに関する連絡を行うこと
      </li>
      <li>
        当社が別途指定する方法により、登録ユーザーから直接プロジェクト事例の依頼を受けること
      </li>
    </ol>
  </li>
</ol>
<h4>第１０条の２（プロジェクト事例の掲載・変更）</h4>
<ol>
  <li>
    エキスパートは、別途当社が定める事項を記載の上、別途当社が定める方式で、プロジェクト事例の概要事項を本サービスサイトに掲載することを当社に申請することができます。
  </li>
  <li>
    当社は、当社所定の基準に基づき審査を行い、掲載に問題がないと判断した場合、プロジェクト事例の概要事項を本サービスサイトに掲載いたします。なお、エキスパートが、送信・アップロードする等して当社の管理するサーバ領域に保存したプロジェクト事例は登録会員コンテンツとして扱われます。
  </li>
  <li>
    当社が、第１項の申請が不適切と判断した場合は、当社の裁量により掲載を拒否することができます。当社は掲載を拒否する理由をエキスパートに伝えることがありますが、その義務は負いません。
  </li>
  <li>
    第３項の措置により、エキスパートに損害が生じた場合であっても、当社は責任を負いません。
  </li>
  <li>
    プロジェクト事例の掲載は第２項の掲載のときから第１０条の３（プロジェクト事例の掲載終了）に基づき掲載終了となるまでの期間とします。
  </li>
  <li>
    エキスパートは、別途当社が定める方式で、掲載済みのプロジェクト事例の記載の変更を求めることができます。当社はかかる変更の申請につき本条に準じて取り扱うものとします。
  </li>
</ol>
<h4>第１０条の３（プロジェクト事例の掲載終了）</h4>
<ol>
  <li>
    当社は、別途当社が定める方法で、エキスパートがプロジェクト事例の掲載の終了をすることを当社に通知した場合、速やかにプロジェクト事例の掲載を終了いたします。
  </li>
  <li>
    当社は、以下の場合にプロジェクト事例の掲載を何ら催告なく一時的に中止又は終了することができます。
    <p>
      ①エキスパートの登録が抹消又は取り消された場合 <br />
      ②第２７条（登録抹消等）第１項により当社がプロジェクト事例の掲載を中止する判断をした場合
      <br />
      ③その他当社がプロジェクト事例の掲載が相当でないと判断した場合
    </p>
  </li>
  <li>
    第２項の措置により、エキスパートに損害が生じた場合であっても、当社は責任を負いません。
  </li>
</ol>
<h4>第１０条の４（Proffit Martサービスの利用料）</h4>
<ol>
  <li>
    登録ユーザーは、当社が別途定める場合を除き、Proffit
    Martサービスを無料で利用できるものとします。なお、本規定は今後も登録ユーザーがProffit
    Martサービスを無料で利用できることを保証するものではなく、将来的に登録ユーザーによるProffit
    Martサービスの利用が有償となることもございます。その場合当社は事前に登録ユーザーに通知をするとともに、Proffit
    Martサービスの利用を継続するかにつき登録ユーザーに確認を取るものとします。
  </li>
  <li>
    エキスパートは、プロジェクト事例の概要事項の本サービスサイトへの掲載料として、毎月翌月分を当月末日までに別途当社が定める月額料金を支払うものとします。なお、月の途中で掲載が開始又は終了した場合も、日割計算は行わず、１ヶ月分の月額料金が発生します。
  </li>
  <li>
    エキスパートは、本サービスを利用してプロジェクト事例への問い合わせをした登録ユーザーとの間で、プロジェクト事例への問い合わせを受けた最後の日から２年以内にコンサルティングその他の役務の提供にかかる契約（以下「コンサルティング契約」といい、問い合わせにかかるプロジェクト事例を提供する契約に限りません。）を締結した場合、Proffit
    Martサービスの利用料として別途当社が定める料金表に定める金額を、別途当社が定める期日までに当社に支払うものとします。
  </li>
  <li>
    エキスパートは、第２項の月額料金及び第３項の利用料を、別途当社が指定する金融機関の口座に振込送金する方法で支払うものとします。振込手数料はエキスパートの負担とします。
  </li>
  <li>
    第２項の規定にかかわらず、プロジェクト事例の問い合わせをした登録ユーザーの部署と異なる部署からの依頼に基づきコンサルティング契約を締結した場合は、エキスパートは第２項に定めるProffit
    Martサービスの利用料の支払義務を負わないものとします。なお、部署が同一か否かは、エキスパートと当社との協議により当社が定めるものとします。当社はかかる判断にあたり、可能な限り登録ユーザーにヒアリングを行うものとします。
  </li>
  <li>
    本条に基づきProffit
    Martサービスの利用料が発生する条件が満たされる場合において、同時にProffitサービスの利用料が発生する条件も満たされる場合、エキスパートはProffitサービスの利用料を支払うものとし、Proffit
    Martサービスの利用料の支払義務は負わないものとします。
  </li>
  <li>
    理由の如何にかかわらず、当社は受領したProffit
    Martサービスの利用料の返還を行う義務を負わないものとします。但し、当社の責により利用料にかかるProffit
    Martサービスの提供が不能となった場合はこの限りではありません。
  </li>
  <li>
    第１３条（報告等）に定める報告を行わなかった場合（事実に反する報告を行った場合を含みます。）その他本条に定めるProffit
    Martサービスの利用料を本規約に従って支払わなかった場合、エキスパートはProffit
    Martサービスの利用料２倍相当額の違約金を直ちに当社に支払うものとします。
  </li>
</ol>
${TERMS_HOTLINE_HTML}
<h4>第１２条（問い合わせへの対応）</h4>
<ol>
  <li>
    エキスパートは、登録ユーザーから問い合わせがあった場合、問い合わせがなされた日の翌日から２営業日以内に問い合わせに対する応答を行うものとします。
  </li>
  <li>
    登録ユーザーは、エキスパートへの依頼以外の目的で問い合わせを行ってはならず、またエキスパートへの問い合わせにあたり、予算の範囲を含め事実に反する事項を伝えてはならないものとします。
  </li>
</ol>
<h4>第１３条（報告等）</h4>
<ol>
  <li>
    エキスパートは、本サービスの利用に関連し、登録ユーザーとの取引その他当社が指定する事項につき当社から質問がなされた場合には、別途当社が定める方法でこれに回答するものとします。
  </li>
  <li>
    エキスパートは、契約の名称、法的性質、契約部署等にかかわらず、登録ユーザーとの間で契約の締結をした場合、締結日から１ヶ月以内にその内容について、別途当社が定める方法で当社に報告するものとします。
  </li>
  <li>
    登録ユーザーは、本サービスの利用に関連し、エキスパートとの取引その他当社が指定する事項につき当社から質問がなされた場合には、別途当社が定める方法でこれに回答するものとします。
  </li>
  <li>
    登録ユーザーは、契約の名称、法的性質、契約部署等にかかわらず、エキスパートとの間で契約の締結をした場合、締結日から１ヶ月以内にその内容について、別途当社が定める方法で当社に報告するものとします。
  </li>
  <li>
    登録会員は、前各項の報告にあたり事実に反する報告をしてはならないものとします。
  </li>
</ol>
<h4>第１４条（評価機能）</h4>
<ol>
  <li>
    エキスパートは、本サービスを利用してエキスパートと契約をした登録ユーザーが当該エキスパートを評価することができる機能（以下「評価機能」といいます。）が本サービスサイト上に設けられており、評価内容が登録会員に対し公開されることについて同意するものとします。
  </li>
  <li>
    登録ユーザーは、本サービスを利用して登録ユーザーと契約をしたエキスパートが当該登録ユーザーを評価することができる評価機能が本サービスサイト上に設けられており、評価内容が登録会員に対し公開されることについて同意するものとします。
  </li>
  <li>
    登録会員は、評価機能による評価を行う際に、虚偽の事実、本サービスに無関係な内容、他人の権利を侵害する内容、公序良俗に反する内容を記述することを禁止します。当社は、当該禁止事項に違反していると判断する評価を削除ないし非公開にすることができます。
  </li>
  <li>
    登録会員は、評価内容について、他の登録会員及び当社をいかなる責任からも免除することについて同意することとします。
  </li>
</ol>
<h4>第１５条（本サービスの停止）</h4>
<ol>
  <li>
    当社は、以下のいずれかに該当する場合には、事前の通知又は告知なく、本サービスの全部又は一部の提供を停止又は中断することができるものとします。
    <ol>
      <li>
        本サービスに係るコンピューター・システムの点検又は保守作業を行う必要がある場合
      </li>
      <li>コンピューター、通信回線等が事故により停止した場合</li>
      <li>
        地震、落雷、風水害、停電、天災地変等の不可抗力により本サービスの運営ができなくなった場合
      </li>
      <li>
        本サービスの改善、改修等のため緊急の停止又は中断の必要がある場合
      </li>
      <li>
        その他、当社が緊急の停止又は中断を必要と判断した場合
      </li>
    </ol>
  </li>
  <li>
    当社は、以下のいずれかに該当する場合には、本サービスサイト上で事前告知のうえ、本サービスの全部又は一部の提供を停止又は中断することができるものとします。
    <ol>
      <li>
        本サービスに係るコンピューター・システムの点検又は保守作業を行う必要がある場合
      </li>
      <li>本サービスの改善、改修等のため必要がある場合</li>
    </ol>
  </li>
  <li>
    当社は、本条に基づき当社が行った措置に基づき登録会員に生じた損害について一切の責任を負いません。
  </li>
</ol>
<h4>第１６条（本サービスの内容の変更、終了）</h4>
<ol>
  <li>
    当社は、事前に通知することなく、当社の都合により、本サービスの内容を変更し、又は本サービスの提供を終了することができます。
  </li>
  <li>
    当社は、本条に基づき当社が行った措置に基づき登録会員に生じた損害について一切の責任を負いません。
  </li>
</ol>
<h4>第１７条（利用環境等）</h4>
<p>
  登録会員は、本サービスを利用するにあたり、必要なパーソナルコンピューター、スマートフォン、通信機器、オペレーションシステム、通信手段及び電力等を、登録会員の費用と責任で用意するものとします。
</p>
<h4>第１８条（登録会員ＩＤ及びパスワードの管理）</h4>
<ol>
  <li>
    登録会員は、自己の責任において、本サービスに関する登録会員ＩＤ及びパスワードを適切に管理及び保管するものとし、これを第三者（登録会員に付与される登録会員ＩＤ及びパスワードについては当該登録会員以外の者を「第三者」とします。）に利用させ、又は貸与、譲渡、名義変更、売買等をしてはならないものとします。なお、登録会員が法人の場合、その役員及び従業員は当該登録会員とみなされます。
  </li>
  <li>
    当社は、登録された登録会員ＩＤ又はパスワードを利用して行われた一切の行為を、登録会員ご本人の行為とみなすことができます。
  </li>
  <li>
    登録会員ＩＤ又はパスワードの管理不十分、使用上の過誤、第三者の使用等によって生じた損害に関する責任は登録会員が負うものとし、当社は一切の責任を負いません。
  </li>
  <li>
    登録会員は、登録会員ＩＤ又はパスワードの盗難があった場合、又は登録会員ＩＤ又はパスワードが第三者に使用されていることが判明した場合には、直ちに当社にその旨を連絡するとともに、当社からの指示がある場合にはこれに従うものとします。
  </li>
</ol>
<h4>第１９条（権利帰属等） </h4>
<ol>
  <li>
    本サービスサイト及び本サービスに関する知的財産権、著作権は全て当社又は当社にライセンスを許諾している者に帰属しており、本利用規約に基づく本サービスの利用提供は、本サービスサイト又は本サービスに関する当社又は当社にライセンスを許諾している者の知的財産権、著作権の使用許諾、利用許諾を意味するものではありません。
  </li>
  <li>
    当社は登録会員からのいかなるフィードバック、要望及び提案について、登録会員の許可無く使用する権限を有するものとします。
  </li>
  <li>
    登録会員は、登録会員コンテンツについて、自らが、送信、アップロード等することについて適法な権利を有していること、及び登録会員コンテンツが第三者の権利を侵害していないことについて、当社に対し表明し、保証するものとします。
  </li>
  <li>
    登録会員は、すべての登録会員コンテンツに対して有する権利を従前どおり保持し、当社が第２０条（コンテンツの取扱い）第２項に定める利用権を除き、登録会員コンテンツにかかる権利を取得することはありません。
  </li>
</ol>
<h4>第２０条（コンテンツの取り扱い）</h4>
<ol>
  <li>
    第１９条（権利帰属等）第１項に拘らず、登録会員は、本サービスの利用目的の範囲で、登録会員の責任で、登録ユーザー又はエキスパートの区分に応じてそれぞれ本サービス上提供される、登録会員コンテンツ及び当社提供コンテンツを利用することができます。但し、本サービスが当然に予定している利用態様を超えた利用（複製、送信、転載、改変等の行為を含みます。）してはなりません。
  </li>
  <li>
    登録会員は、当社に対し、当該登録会員の登録会員コンテンツのすべての著作権について、当社が当該登録会員に本サービスを提供するために必要な範囲で、必要な態様（複製、公衆送信、翻案、翻訳、上演、演奏、上映、口述、展示、貸与、二次的利用、再許諾を含むが、これらに限られません。）で、国内外、期間の限定なく利用することができる、無償のサブライセンス可能な、非独占的利用を許諾します。また、登録会員は、当社に対し、登録会員コンテンツの著作者人格権を行使しないことについて同意するものとします。
  </li>
  <li>
    当社は、法令又は本利用規約の遵守状況等を確認する必要がある場合、登録会員コンテンツの内容を確認することができます。但し、当社はかかる確認を行う義務を負うものではありません。
  </li>
  <li>
    登録会員が登録会員コンテンツ等に関し法令若しくは本利用規約に違反し又は違反するおそれのあると当社が認めた場合、その他業務上の必要性がある場合には、当社は、あらかじめ登録会員に通知することなく、当社の管理するサーバから登録会員コンテンツを削除する等の方法により、本サービス又は登録会員コンテンツを利用できないようにすることができます。そのため、登録会員は常に登録会員コンテンツのバックアップを作成しておくことが推奨されます。また、当社は、かかる場合に本サービス又は登録会員コンテンツを利用できなくなったことについて、登録会員に対し一切責任を負いません。
  </li>
</ol>
<h4>第２１条（登録会員情報の取り扱い）</h4>
<ol>
  <li>
    当社は、本利用規約の他、当社のプライバシーポリシーに従って、登録会員の個人情報（個人情報の保護に関する法律に定義される個人情報をいいます。以下同じ。）を取り扱います。
  </li>
  <li>
    当社は、法令による場合、又は、裁判所、行政機関その他公的機関、日本証券業協会等の自主規制機関の命令、要請がある場合には、登録会員の個人情報を開示することができます。
  </li>
</ol>
<h4>第２２条（ビックデータの取り扱い）</h4>
<ol>
  <li>
    当社は、以下に記載する情報（以下、当社が収集する情報を総称して「当社取得情報」といいます。）について、統計情報を作成することができるものとします。
    <ol>
      <li>登録事項その他登録会員が当社に提供した情報</li>
      <li>
        登録会員が本サービスの利用・閲覧に伴って自動的に送信される情報
      </li>
      <li>登録会員コンテンツ</li>
    </ol>
  </li>
  <li>
    当社は、第１項に基づき取得した当社取得情報に個人情報が含まれる場合は、個人として識別できる情報（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含む）ではない情報に改変するものとします。
  </li>
  <li>
    当社は、当社取得情報を以下の各号の目的で利用することができるものとします。なお、第７号に定める利用は当社取得情報に不可逆的な統計処理をした統計情報のみを対象とします。
    <ol>
      <li>登録会員に適したサービス等をご提供するため</li>
      <li>登録会員からのお問い合わせに対応するため</li>
      <li>
        本サービス等を安全にご提供するため（これには、本利用規約に違反している登録会員を発見して当該登録会員に通知をしたり、本サービス等を悪用した詐欺や不正アクセスなどの不正行為を調査・検出・予防したり、これらに対応することが含まれます。）
      </li>
      <li>
        本サービス等の改善及び新たなサービス等を検討するため
      </li>
      <li>本サービス等のご利用状況等を調査、分析するため</li>
      <li>
        当社の製品やサービスに反映させ、又はマーケティング調査に活用するため
      </li>
      <li>
        他社へ販売し、又は公開（販売先による公開を含みます。）させて頂くため
      </li>
    </ol>
  </li>
  <li>
    当社は、本条に従って、当社取得情報を適切に取り扱います。当社取得情報を適切に取り扱うため、社内規程及び組織を整備し、パーソナルデータを処理する情報システムの安全を確保します。
  </li>
</ol>
<h4 id="item_${TERMS_CONFIDENTIALITY_SECTION_ID}">第２３条（秘密保持）</h4>
<ol>
  <li>
    当社は、本利用規約に定めのある場合及び登録会員の事前の書面による承諾がある場合を除き、登録会員に関する情報を秘密に取り扱います。
  </li>
  <li>
    登録会員は、本サービスを通じて獲得した全ての情報につき、秘密に取り扱います。
  </li>
  <li>
    前２項に拘らず、以下の情報については当社及び登録会員は秘密保持義務を負わないものとします。但し、個人情報についてはこの限りではありません。
    <ol>
      <li>
        相手方の開示時点で、既に公知又は一般に入手可能であった情報
      </li>
      <li>
        相手方の開示後に、自己の責めに帰すべき事由によらず公知又は一般に入手可能になった情報
      </li>
      <li>
        相手方の開示時点で、既に第三者から秘密保持義務を課されることなく自己が所有していたことを証明し得る情報
      </li>
      <li>
        相手方の開示後に、秘密情報を用いずに自己が独自に開発したことを証明し得る情報
      </li>
      <li>
        第三者から秘密保持義務を課されることなく正当に入手した情報
      </li>
    </ol>
  </li>
</ol>
<h4>第２４条（禁止事項）</h4>
登録会員は、本サービスの利用にあたり、以下の各号のいずれかに該当する行為又は該当すると当社が判断する行為をしてはなりません。
<ol>
  <li>
    本サービスを利用する上で必要となる専用のソフトウェア（以下「本アプリ」といいます。）の改変、リバースエンジニアリング（主にソフトウェアの内容を解析して、人間が読み取り可能な形に変換することを指します。）、逆コンパイル、逆アセンブルその他これらに類する行為
  </li>
  <li>
    本サービス利用目的を超えて本サービスを使用する行為、又は当社が許諾した利用態様を超えて、本サービスのコンテンツを複製、公衆送信、頒布、譲渡、貸与する行為
  </li>
  <li>
    本サービスを第三者に利用させる行為又は第三者が利用できる状態にする行為
  </li>
  <li>
    本サービスを通じ、以下に該当し、又は該当すると当社が判断する情報を送信、アップロード等すること
    <p>
      <br />
      ・コンピューター・ウイルスその他の有害なコンピューター・プログラムを含む情報
      <br />
      ・当社、本サービスの他の登録会員又はその他の第三者の名誉、信用その他の権利を毀損する表現を含む情報
      <br />
      ・反社会的な表現や他人に不快感を与える表現を含む情報
      <br />
      ・チェーンメール等の第三者への情報の拡散を求める情報
      <br />
    </p>
  </li>
  <li>
    本サービスのネットワーク又はシステム等に過度な負担をかける行為
  </li>
  <li>
    当社のネットワーク又はシステム等に不正にアクセスし、又は不正なアクセスを試みる行為
  </li>
  <li>
    本サービスの他の登録会員のＩＤ又はパスワードを利用する行為
  </li>
  <li>第三者になりすます行為</li>
  <li>
    当社、本サービスの他の登録会員又はその他の第三者の知的財産権、肖像権、プライバシー、名誉、その他の権利又は利益を侵害する行為
  </li>
  <li>
    本サービスの他の登録会員又はその他の第三者の個人情報、登録情報、利用履歴情報等を収集、開示又は提供する行為
  </li>
  <li>
    本利用規約で明示的に認められる以外の方法による宣伝、広告、勧誘、又は営業行為
  </li>
  <li>宗教活動又は宗教団体への勧誘行為</li>
  <li>反社会勢力への利益供与</li>
  <li>本サービスの運営を妨害するおそれのある行為</li>
  <li>
    当社、本サービスの他の登録会員又はその他の第三者に対する詐欺又は強迫行為
  </li>
  <li>
    当社、本サービスの他の登録会員又はその他の第三者に不利益、損害、不快感を与える行為
  </li>
  <li>
    法令、裁判所の確定した判決、決定若しくは命令、又は法令上拘束力のある行政措置に違反する行為
  </li>
  <li>公序良俗に反する行為</li>
  <li>
    本サービスサイト上で掲載する本サービス利用に関するルールに抵触する行為
  </li>
  <li>前各号の行為を直接又は間接に惹起し、又は容易にする行為</li>
  <li>その他、当社が不適切と判断する行為</li>
</ol>
<h4>第２５条（登録会員によるアカウントの削除）</h4>
<p>
  登録会員は、いつでもアカウントを削除し、本サービスの利用を終了することができます。この場合、当社が保有する登録会員ご本人に関する情報は、個人情報保護法その他の関連法規及びプライバシーポリシーに従い処理されます。なお、当社は削除されたアカウント上の情報についてバックアップその他情報を保存する義務を負わないものとします。
</p>
<h4>第２６条（利用停止等）</h4>
<ol>
  <li>
    当社は、登録会員が本利用規約に違反し又は違反するおそれがあると認めた場合、あらかじめ登録会員に通知することなく、アカウントを停止することができます。アカウントの停止がなされた登録会員は本サービスの利用ができなくなります。
  </li>
  <li>
    当社は、他の事業者が提供するアカウント（以下「他社アカウント」といいます。）から本サービスにログインすることを認める場合がありますが、他社アカウントから本サービスにログインする登録会員は、当該他社アカウントが削除される等により、当該他社アカウントがこれを提供する事業者によって認証されなくなった場合、当該他社アカウントにより本サービスにログインして、本サービスを利用することはできなくなります。当社はかかる事態に対し一切の責任を負いません。
  </li>
</ol>
<h4>第２７条（登録抹消等）</h4>
<ol>
  <li>
    当社は、登録会員が、以下の各号のいずれかの事由に該当する場合は、事前に通知又は催告することなく、登録会員コンテンツを削除し若しくは登録会員について本サービスの利用を停止し、又はアカウント及び登録会員としての登録を抹消、若しくはサービス利用契約を解除することができます。なお、当社は削除されたアカウント上の情報についてバックアップその他情報を保存する義務を負わないものとします。
    <ol>
      <li>本利用規約のいずれかの条項に違反した場合</li>
      <li>
        支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申立てがあった場合
      </li>
      <li>
        当社からの問い合わせその他の回答を求める連絡に対して、３０日間以上応答がない場合
      </li>
      <li>第３条（登録）第７項各号に該当する場合</li>
      <li>
        その他、当社が本サービスの利用、登録会員としての登録、又はサービス利用契約の継続を適当でないと判断した場合
      </li>
    </ol>
  </li>
  <li>
    前項各号のいずれかの事由に該当した場合、登録会員は、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。
  </li>
</ol>
<h4>第２８条（当社に対する補償）</h4>
<p>
  登録会員は、登録会員が法令又は本利用規約に違反して本サービスを利用したことに起因して（かかる趣旨のクレームを第三者より当社が受けた場合を含みます。）、当社が直接的若しくは間接的に何らかの損害、損失又は費用負担（弁護士費用の負担を含みます。）を被った場合、当社の請求にしたがって直ちにこれを賠償又は補償しなければなりません。
</p>
<h4>第２９条（当社の責任の免除・限定）</h4>
<ol>
  <li>
    当社は、本サービスに起因して登録会員に生じたあらゆる損害について一切の責任を負いません。
  </li>
  <li>
    何らかの理由で当社が登録会員に対し損害賠償責任を負う場合といえども、かかる責任は以下の各号に定める金額を上限とします。
    <ol>
      <li>
        有償で提供される本サービスに起因して登録会員に生じた損害については、当社が登録会員から当該損害の発生した月に受領した利用料の額。
      </li>
      <li>
        無償で提供される本サービスに起因して登録会員に生じた損害については、登録会員が当該本サービスの利用に際して当該損害が発生した月に費消した回線費用の額又は５００円のうち低い金額。
      </li>
    </ol>
  </li>
</ol>
<h4>第３０条（契約上の地位の譲渡）</h4>
<ol>
  <li>
    登録会員は、当社の書面による事前の承諾なく、当社との間の契約上の地位又は本利用規約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。
  </li>
  <li>
    当社は、本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴い登録会員との間の契約上の地位、本利用規約及び個別利用規約に基づく権利及び義務並びに登録会員の登録事項その他の情報を当該事業譲渡の譲受人に譲渡することができるものとし、登録会員はかかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他の事業が移転するあらゆる場合を含むものとします。
  </li>
</ol>
<h4>第３１条（本利用規約等の変更）</h4>
<p>
  当社は、当社が必要と判断する場合、事前の通知又は告知なく、いつでも、本利用規約及び個別利用規約を変更できるものとします。変更後の本利用規約及び個別利用規約は、本サービスサイト内の適宜の場所に掲示された時点からその効力を生じるものとし、登録会員は本利用規約及び個別利用規約の変更後も本サービスを使い続けることにより、変更後の本利用規約及び個別利用規約に対する有効かつ取消不能な同意をしたものとみなされます。
</p>
<h4>第３２条（連絡・通知）</h4>
<ol>
  <li>
    本サービスに関する当社から登録会員への通知、告知その他の連絡は、本サービスサイト内の適宜の場所への掲示その他、当社が適当と判断する方法により行ないます。
  </li>
  <li>
    本サービスに関する登録会員から当社への通知又は連絡は、本サービスサイト内の適宜の場所に設置するお問い合わせフォームの送信又は当社が指定する方法により行っていただきます。
  </li>
</ol>
<h4>第３３条（分離可能性）</h4>
<p>
  本利用規約のいずれかの条項又はその一部が、法令等により無効又は執行不能と判断された場合であっても、本利用規約の残りの規定及び一部が無効又は執行不能と判断された規定の残りの部分は、継続して完全な効力を有するものとします。
</p>
<h4>第３４条（残存条項）</h4>
<p>
  本契約中、各条項に特に指定があるものに加え、第９条の２（Proffitサービスの利用料）、第９条の３（Proffitサービスにおけるキャンセルの取扱い）、第１０条の４（Proffit
  Martサービスの利用料）、第１３条（報告等）、第１８条（登録会員ＩＤ及びパスワードの管理）、第１９条（権利帰属等）、第２０条（コンテンツの取り扱い）、第２１条（登録会員情報の取り扱い）、第２２条（ビッグデータの取り扱い）、第２３条（秘密保持）、第２８条（当社に対する補償）、第２９条（当社の責任の免除・限定）、第３０条（契約上の地位の譲渡）、第３２条（連絡・通知）、第３３条（分離可能性）、本条及び第３５条（準拠法及び管轄裁判所）は、本契約終了後もその効力を維持するものとします。
</p>
<h4>第３５条（準拠法及び管轄裁判所）</h4>
<ol>
  <li>
    本利用規約は日本語を正文とし、その準拠法は日本法とします。
  </li>
  <li>
    本利用規約又はサービス利用契約に起因し、又は関連する一切の紛争については、東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とします。かかる管轄裁判所で得られた勝訴判決は、いずれの国の裁判所においても執行可能とします。
  </li>
</ol>
<p>（附則）</p>
<p>本規約は、２０２４年１１月１８日より施行致します。</p>
<p>２０２４年１１月１８日改訂</p>
<p>２０２０年４月２７日改訂</p>
<p>２０１９年１１月２０日改訂</p>
<p>２０１９年３月１５日改訂</p>
<p>２０１８年４月１０日制定</p>`;
